/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ProtectedMakePaymentRouteImport } from './routes/_protected/make-payment'

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedMakePaymentRoute = ProtectedMakePaymentRouteImport.update({
  id: '/make-payment',
  path: '/make-payment',
  getParentRoute: () => ProtectedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof ProtectedRouteWithChildren
  '/make-payment': typeof ProtectedMakePaymentRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof ProtectedRouteWithChildren
  '/make-payment': typeof ProtectedMakePaymentRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_protected/make-payment': typeof ProtectedMakePaymentRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/$' | '/' | '/make-payment'
  fileRoutesByTo: FileRoutesByTo
  to: '/$' | '/' | '/make-payment'
  id: '__root__' | '/$' | '/_protected' | '/_protected/make-payment'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/make-payment': {
      id: '/_protected/make-payment'
      path: '/make-payment'
      fullPath: '/make-payment'
      preLoaderRoute: typeof ProtectedMakePaymentRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedMakePaymentRoute: typeof ProtectedMakePaymentRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedMakePaymentRoute: ProtectedMakePaymentRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
